import React, { useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { SortingRule } from 'react-table';
import { Col, Row } from 'reactstrap';
import TableComponent from '../TableComponent';
import { PartsAndServicesQuotationDTO } from '../../models/Quotation/PartsAndServicesQuotationDTO';
import { Utilities } from '../../helpers/Utilities';

export type PartsTableComponentType = {
    reloadParts: boolean;
    goToPage: number;
    currentPage: number;
    isComplete: boolean;
    onPartsChange: (parts: PartsAndServicesQuotationDTO[]) => void;
    initialParts: PartsAndServicesQuotationDTO[];
    quotationType: string;
};


const ReviewQuotationParts: React.FC<PartsTableComponentType> = ({
    reloadParts,
    goToPage,
    currentPage,
    isComplete,
    onPartsChange,
    initialParts,
    quotationType
  }) => {
    const [isLoadingTable, setIsLoadingTable] = useState<boolean>(false);
    const [parts, setParts] = useState<PartsAndServicesQuotationDTO[]>(initialParts || []);
    const [totalPages, setTotalPages] = useState<number>(0);
    const pageSizes: number[] = [5, 15, 30];
    const [pageSize, setPageSize] = useState<number>(5);
    const [initialSortBy] = useState<SortingRule<object>[]>([]);

    useEffect(() => {
        onPartsChange(parts);
        const updatedParts = initialParts.map(part => {
            const totalPrice = Utilities.calculateTotalPrice(part.quantity, part.sellingPrice);
            return { ...part, totalPrice };
          });
            setParts(updatedParts);
      }, [onPartsChange]);


    const columns = React.useMemo(() => {
            return [
                {
                    Header: <FormattedMessage id="Screens.Quotation.Parts.Label.Code" />,
                    accessor: "partId",
                    width: 15,
                    Cell: ({ cell }: { cell: { value: number } }) => {
                        const partId = cell.value;
                        return (
                            <div>
                                {partId === 0 ? (
                                    <FormattedMessage id="Screens.Quotation.Parts.Message.NoPart" />
                                ) : (
                                    partId
                                )}
                            </div>
                        );
                    },
                },
                {
                    Header: <FormattedMessage id="Screens.Quotation.Parts.Label.Name" />,
                    accessor: "partName",
                    width: 25,
                },
                {
                    Header: <FormattedMessage id="Screens.Quotation.Parts.Label.Quantity" />,
                    accessor: "quantity",
                    width: 20,
                },
                {
                    Header: <FormattedMessage id="Screens.Quotation.Parts.Label.SellingPrice" />,
                    accessor: "sellingPrice",
                    width: 20,
                },
                {
                    Header: <FormattedMessage id="Screens.Quotation.Parts.Label.TotalValue" />,
                    accessor: "totalPrice",
                    width: 20,
                },
            ];
        }, []);
    return (
        <div>
            <Row xl={12} lg={12} md={12} sm={12} xs={12}>
                <Row style={{ margin: "1rem 0px" }}>
                    <TableComponent
                        goToPage={goToPage}
                        loading={isLoadingTable}
                        pageCount={totalPages}
                        columns={columns.map(column => ({
                            ...column,
                            accessor: String(column.accessor) 
                        }))}
                        manualPagination={true}
                        fetchData={() => {}}
                        pageSizes={pageSizes}
                        initialPage={currentPage}
                        initialPageSize={pageSize}
                        initialSortBy={initialSortBy}
                        data={parts}
                        dontOrderLastCollumn={true}
                        dontOrderFirstCollumn={false}
                    />
                </Row>
            </Row>
        </div>
    )
}
export default ReviewQuotationParts